module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconfig = config || {}\nconst additionalMainClasses = ['loading']\nconst additionalSubClasses = ['subForm']\nlet elementType = ''\nlet childrenRenderedViaFormMapping = false\nif(config.contextClass){\nadditionalMainClasses.push(config.contextClass);\nadditionalSubClasses.push(config.contextClass);\n}\nif(config.isProtocolActionForm){\nadditionalMainClasses.push('isProtocolActionForm');\nadditionalSubClasses.push('isProtocolActionForm');\n}\nif(config.isHorizontal){\nadditionalMainClasses.push('isHorizontal');\nadditionalSubClasses.push('isHorizontal');\n}\nif(config.isFullyHorizontal){\nadditionalMainClasses.push('isFullyHorizontal');\nadditionalSubClasses.push('isFullyHorizontal');\n}\nif(config.isFullyVertical){\nadditionalMainClasses.push('isFullyVertical');\nadditionalSubClasses.push('isFullyVertical');\n}\nif(config.fieldAlignJustify){\nadditionalMainClasses.push('fieldAlignJustify');\nadditionalSubClasses.push('fieldAlignJustify');\n}\nif(config.subFormAlias){\n%><div class=\"<%= additionalSubClasses.join(' ') %>\" data-sub-form-alias=\"<%- config.subFormAlias %>\"><%\n} else if (config.simpleSubForm) {\n%><div class=\"<%= additionalSubClasses.join(' ') %>\"><%\n} else {\n%><form class=\"<%= additionalMainClasses.join(' ') %>\"><%\n}\nif(!config || !config.preventModelFieldsBeingRendered){\n%><div class=\"cols\"><%\nutils.forEach(formMapping.cols, function(col){\nconst colClasses = ['col']\nlet colWrapper = false\nif(utils.isObject(col) && (col || {}).content){\nif(col.class){\ncolClasses.push(col.class)\n}\ncolWrapper = col.colWrapper\ncol = col.content\n}\n%><div class=\"<%- colClasses.join(' ') %>\"><%\nif(colWrapper){\n%><div class=\"colWrapper\"><%\n}\nutils.forEach(col, function(element){\nif ((elementType = (element || {}).type || 'field') === 'section'){\nif((element || {}).name === undefined){\nchildrenRenderedViaFormMapping = true;\n%><%- helpers.renderSection() %><%\n} else {\n%><%- helpers.renderSection(element.name) %><%\n}\n}\nelse {\nif((element || {}).modelFieldIndex === undefined || (model.fields || {})[element.modelFieldIndex] !== undefined){\nif(config.disabled){\nelement.fieldConfig = element.fieldConfig || {};\nelement.fieldConfig.disabled = true;\n}\nconst elementConfig = {\npreventAllFieldLabels: \t\t\t\tconfig.preventAllFieldLabels,\nisFieldCodeSelector: \t\t\t\tconfig.isFieldCodeSelector,\npreventFieldCodeSelectorFields: \tconfig.preventFieldCodeSelectorFields,\nisHorizontal: \t\t\t\t\t\tconfig.isHorizontal,\nisFullyHorizontal: \t\t\t\t\tconfig.isFullyHorizontal,\nisFullyVertical: \t\t\t\t\tconfig.isFullyVertical,\n}\n%><%- include('elements/' + element.type, { formMapping: element, model: model, config: elementConfig }); %><%\n}\n}\n});\nif(colWrapper){\n%></div><%\n}\n%></div><%\n});\n%></div><%\n}\nif(!childrenRenderedViaFormMapping){\n%><%- helpers.renderSection(); %><%\n}\nif(config.subFormAlias){\n%></div><%\n} else if (config.simpleSubForm) {\n%></div><%\n} else {\n%></form><%\n}\n%>"
  , __filename = "..\\frontend-controller\\baseComponents\\form\\form.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
config = config || {}
const additionalMainClasses = ['loading']
const additionalSubClasses = ['subForm']
let elementType = ''
let childrenRenderedViaFormMapping = false
if(config.contextClass){
additionalMainClasses.push(config.contextClass);
additionalSubClasses.push(config.contextClass);
}
if(config.isProtocolActionForm){
additionalMainClasses.push('isProtocolActionForm');
additionalSubClasses.push('isProtocolActionForm');
}
if(config.isHorizontal){
additionalMainClasses.push('isHorizontal');
additionalSubClasses.push('isHorizontal');
}
if(config.isFullyHorizontal){
additionalMainClasses.push('isFullyHorizontal');
additionalSubClasses.push('isFullyHorizontal');
}
if(config.isFullyVertical){
additionalMainClasses.push('isFullyVertical');
additionalSubClasses.push('isFullyVertical');
}
if(config.fieldAlignJustify){
additionalMainClasses.push('fieldAlignJustify');
additionalSubClasses.push('fieldAlignJustify');
}
if(config.subFormAlias){

    ; __line = 32
    ; __append("<div class=\"")
    ; __append(escapeFn( additionalSubClasses.join(' ') ))
    ; __append("\" data-sub-form-alias=\"")
    ; __append( config.subFormAlias )
    ; __append("\">")
    ; 
} else if (config.simpleSubForm) {

    ; __line = 34
    ; __append("<div class=\"")
    ; __append(escapeFn( additionalSubClasses.join(' ') ))
    ; __append("\">")
    ; 
} else {

    ; __line = 36
    ; __append("<form class=\"")
    ; __append(escapeFn( additionalMainClasses.join(' ') ))
    ; __append("\">")
    ; 
}
if(!config || !config.preventModelFieldsBeingRendered){

    ; __line = 39
    ; __append("<div class=\"cols\">")
    ; 
utils.forEach(formMapping.cols, function(col){
const colClasses = ['col']
let colWrapper = false
if(utils.isObject(col) && (col || {}).content){
if(col.class){
colClasses.push(col.class)
}
colWrapper = col.colWrapper
col = col.content
}

    ; __line = 50
    ; __append("<div class=\"")
    ; __append( colClasses.join(' ') )
    ; __append("\">")
    ; 
if(colWrapper){

    ; __line = 52
    ; __append("<div class=\"colWrapper\">")
    ; 
}
utils.forEach(col, function(element){
if ((elementType = (element || {}).type || 'field') === 'section'){
if((element || {}).name === undefined){
childrenRenderedViaFormMapping = true;

    ; __line = 58
    ; __append( helpers.renderSection() )
    ; 
} else {

    ; __line = 60
    ; __append( helpers.renderSection(element.name) )
    ; 
}
}
else {
if((element || {}).modelFieldIndex === undefined || (model.fields || {})[element.modelFieldIndex] !== undefined){
if(config.disabled){
element.fieldConfig = element.fieldConfig || {};
element.fieldConfig.disabled = true;
}
const elementConfig = {
preventAllFieldLabels: 				config.preventAllFieldLabels,
isFieldCodeSelector: 				config.isFieldCodeSelector,
preventFieldCodeSelectorFields: 	config.preventFieldCodeSelectorFields,
isHorizontal: 						config.isHorizontal,
isFullyHorizontal: 					config.isFullyHorizontal,
isFullyVertical: 					config.isFullyVertical,
}

    ; __line = 77
    ; __append( include('elements/' + element.type, { formMapping: element, model: model, config: elementConfig }) )
    ; 
}
}
});
if(colWrapper){

    ; __line = 82
    ; __append("</div>")
    ; 
}

    ; __line = 84
    ; __append("</div>")
    ; 
});

    ; __line = 86
    ; __append("</div>")
    ; 
}
if(!childrenRenderedViaFormMapping){

    ; __line = 89
    ; __append( helpers.renderSection() )
    ; 
}
if(config.subFormAlias){

    ; __line = 92
    ; __append("</div>")
    ; 
} else if (config.simpleSubForm) {

    ; __line = 94
    ; __append("</div>")
    ; 
} else {

    ; __line = 96
    ; __append("</form>")
    ; 
}

    ; __line = 98
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\frontend-controller\baseComponents\form\form.ejs

}